export var InterviewEventEnum;
(function (InterviewEventEnum) {
    InterviewEventEnum["START"] = "START";
    InterviewEventEnum["SUBMIT"] = "SUBMIT";
    InterviewEventEnum["END_TEST"] = "END_TEST";
    InterviewEventEnum["AUTO_END_TEST"] = "AUTO_END_TEST";
    InterviewEventEnum["LIVE_PROCTORING_VIOLATION"] = "LIVE_PROCTORING_VIOLATION";
})(InterviewEventEnum || (InterviewEventEnum = {}));
